module.exports = __webpack_public_path__ + "static/media/file-add-symbol.8f39b003.svg";